export enum LotConstructionTypes {
  FEES = 'fees',
  PERMITS = 'permits',
  INSPECTIONS = 'inspections',
}

export enum LotFeeStatus {
  APPLIED = 'applied',
  OUTSTANDING = 'outstanding',
  CONFIRMED = 'confirmed',
}

export enum LotPermitsStatus {
  PENDING = 'pending',
  APPLIED = 'applied',
  ISSUED = 'issued',
  COMPLETED = 'completed',
  REJECTED = 'rejected',
}

export enum LotInspectionsStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  APPLIED = 'applied',
  REQUESTED = 'requested',
  CANCELED = 'canceled',
  RESTARTED = 'restarted'
}

export enum ElevationStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  DENIED = 'denied',
}

export enum FieldTypes {
  TEXT = 'text',
  DATE = 'date',
  CURRENCY = 'currency',
  STATUS = 'status',
}

export enum Events {
  CONSTRUCTION_EVENT = 'CONSTRUCTION_EVENT',
}

export enum EventTypes {
  FEE = 1,
  INSPECTION = 2,
  PERMIT = 3,
}
